// extracted by mini-css-extract-plugin
module.exports = {"view":"collection_view_2j7RG","content":"collection_content_k3DYT"};